export const SELECT_DATE_RANGES = {
  today: { value: 'today', label: 'Today' },
  tomorrow: { value: 'tomorrow', label: 'Tomorrow' },
  yesterday: { value: 'yesterday', label: 'Yesterday' },
  last7days: { value: 'last7days', label: 'Last 7 Days' },
  last30days: { value: 'last30days', label: 'Last 30 Days' },
  thisMonth: { value: 'thisMonth', label: 'This Month' },
  lastMonth: { value: 'lastMonth', label: 'Last Month' },
  custom: { value: 'custom', label: 'Custom Range' }
} as const;
